import { ReturnedAction } from '../reduxTypes';

export const setClient = (value: string): ReturnedAction => ({
  type: 'SET_CLIENT',
  value
});
